import React from 'react'

const NotificationInput = ({value = {time: 0, unit: 'hours'}, onChange = (e, v) => {}}) => {
  const handleChangeText = e => {
    const v = parseInt(e.target.value)
    const _v = isNaN(v) ? 0 : Math.abs(v)
    if (_v <= 9999) {
      onChange(e, {...value, time: _v})
    }
  }

  const handleChangeSelect = e => {
    onChange(e, {...value, unit: e.target.value})
  }

  return (
    <div className={`ap-input-group`}>
      <input
        value={value.time || '-'}
        onChange={handleChangeText}
        className={`ap-input-group__item_notification`}
        style={{
          flex: '0 0 50px',
          width: '50px',
          padding: '8px',
          textAlign: 'center',
        }}
      />
      <select
        value={value.unit || ''}
        onChange={handleChangeSelect}
        className={`ap-input-group__item_notification`}
        style={{
          flex: '0 0 78px',
          width: '78px',
          cursor: 'pointer',
        }}
      >
        <option value="minutes">Minutes</option>
        <option value="hours">Hours</option>
        <option value="days">Days</option>
      </select>
    </div>
  )
}

export default NotificationInput
